import React from 'react';

/**
 * Reusable Confirmation Dialog Component (MUI Version)
 * 
 * @param {boolean} isOpen - Controls dialog visibility
 * @param {function} onClose - Callback when dialog closes
 * @param {function} onConfirm - Callback when user confirms action
 * @param {string} title - Dialog title
 * @param {string} message - Main message to display
 * @param {string} confirmText - Text for confirm button (default: "Confirm")
 * @param {string} cancelText - Text for cancel button (default: "Cancel")
 * @param {string} type - Dialog type: 'danger', 'warning', 'info', 'success' (default: 'info')
 * @param {boolean} loading - Show loading state on confirm button
 */
const ConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  subMessage,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'info',
  loading = false,
  icon = null
}) => {
  const getHeaderClass = () => {
    switch (type) {
      case 'danger':
        return 'bg-danger text-white';
      case 'warning':
        return 'bg-warning';
      case 'success':
        return 'bg-success text-white';
      case 'info':
      default:
        return 'bg-primary text-white';
    }
  };

  return (
    <div className={`modal ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none', zIndex: 2000 }} tabIndex="-1" role="dialog" aria-modal="true">
      <div className="modal-dialog modal-sm" role="document" style={{ zIndex: 2001 }}>
        <div className="modal-content">
          <div className={`modal-header ${getHeaderClass()}`}>
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="mb-2">{message}</p>
            {subMessage && (
              <small className="text-muted">{subMessage}</small>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>{cancelText}</button>
            <button type="button" className="btn btn-primary" onClick={onConfirm} disabled={loading}>{loading ? 'Processing...' : confirmText}</button>
          </div>
        </div>
      </div>
      {isOpen && <div className="modal-backdrop show" style={{ zIndex: 1999 }}></div>}
    </div>
  );
};

export default ConfirmationDialog;
